import React, {Component} from 'react'
import {connect} from 'react-redux'
import {browserHistory} from 'react-router'
import axios from 'axios'
import qs from 'qs'
import {ActionSheet, Dialog, LoadMore, Toast, Toptips} from 'react-weui'
import {NoneItem} from '../components/details'
import {Preload, WKError} from '../components'
import {WKCommentDialog, WKInfiniteScroll} from '../components/wk'
import {TimeStream} from '../utils'
import errorImg from '../images/no-source.png'

import '../css/page/UserReviewsPage.css'

class UserReviewsPage extends Component {
    constructor(props) {
        super(props);
        let defaultAction = [
            {label: '私密回复', onClick: () => this.handleReply()},
            {label: '删除评论', onClick: () => this.handleDialog('delete')},
            {label: '删除并拉黑', className: 'delete-black', onClick: () => this.handleDialog('deleteAndBlack')}
        ]
        let recordAction = [
            {label: '设为精选', onClick: () => this.handleDialog('filtered')},
            {label: '置顶精选', onClick: () => this.handleDialog('top')},
            ...defaultAction
        ]
        this.state = {
            defaultAction,
            recordAction,
            hasUnread: false,
            hasSplitUnread: false,
            initialized: false,
            isActionSheet: false,
            isPending: false,
            isShowPrivateReplyDialog: false,
            operationDiscuss: null,
            successToast: {show: false, content: ''},
            tip: {show: false, content: '', type: 'warn'},
            defaultDialog: {
                title: '',
                buttons: [],
                show: false,
                content: ''
            }
        };
        this.showTip = this.showTip.bind(this)
        this.showOperation = this.showOperation.bind(this)
        this.showSuccessToast = this.showSuccessToast.bind(this)
        this.close = this.close.bind(this)
        this.manageDiscuss = this.manageDiscuss.bind(this)
        this.handleDialog = this.handleDialog.bind(this)
        this.handleSendPrivateComment = this.handleSendPrivateComment.bind(this)
        this.deleteDiscuss = this.deleteDiscuss.bind(this)
        this.handleReply = this.handleReply.bind(this)
    }

    close() {
        let {defaultDialog, isActionSheet} = this.state
        defaultDialog.show = false
        isActionSheet = false
        this.setState({defaultDialog, isActionSheet})
    }

    handleReply() {
        if (this.props.account.id === this.state.operationDiscuss.account.id) {
            return this.showTip('不能私密回复自己')
        }
        this.close()
        this.setState({isShowPrivateReplyDialog: true})
    }

    handleDialog(action) {
        let {defaultDialog} = this.state
        let title = '', content = ''

        switch (action) {
            case 'filtered':
                title = '设为精选'
                content = '将在课程评论区展示，可到评论区进行公开回复，确定设为精选吗？'
                break;
            case 'top':
                title = '置顶精选'
                content = '将在课程评论区置顶展示，可到评论区进行公开回复，确定置顶精选吗？'
                break;
            case 'delete':
                title = '删除评论'
                content = '删除评论后将无法找回，确定删除评论吗？'
                break;
            case 'deleteAndBlack':
                title = '拉黑用户'
                content = '确定删除评论并拉黑用户吗？'
                break;
            default:
                break;
        }
        defaultDialog.title = title
        defaultDialog.content = content
        defaultDialog.show = true
        if (['delete', 'deleteAndBlack'].includes(action)) {
            defaultDialog.buttons = [{
                type: 'default',
                label: '取消',
                onClick: this.close
            }, {
                type: 'primary',
                label: '确定',
                onClick: () => action === 'delete' ? this.deleteDiscuss() : this.deleteAndBlack()
            }]
        }

        if (['filtered', 'top'].includes(action)) {
            defaultDialog.buttons = [{
                type: 'default',
                label: '取消',
                onClick: this.close
            }, {
                type: 'primary',
                label: '确定',
                onClick: () => this.manageDiscuss(action)
            }]
        }
        this.setState({isActionSheet: false, defaultDialog})
    }

    manageDiscuss(action) {
        let {operationDiscuss, discusses} = this.state
        this.setState({isPending: true})
        axios.post(`/api/lecture/${operationDiscuss.lecture.id}/discuss/${operationDiscuss.id}/manage`, qs.stringify({
            action,
        })).then(res => {
            this.setState({isPending: false})
            if (res.data.code === 0) {
                let index = discusses.findIndex(item => item.id === operationDiscuss.id)
                if (action === 'filtered') {
                    discusses[index].is_filtered = true
                }
                if (action === 'top') {
                    discusses[index].is_top = true
                    discusses[index].is_filtered = true
                }
                if (action === 'cancel_top') {
                    discusses[index].is_top = false
                }
                if (action === 'cancel_filtered') {
                    discusses[index].is_top = false
                    discusses[index].is_filtered = false
                }
                this.setState({discusses})
                if (['cancel_top', 'cancel_filtered'].includes(action)) {
                    this.showSuccessToast('取消成功')
                } else {
                    this.showSuccessToast('')
                }
            }
            this.close()
        })
    }

    showOperation(e) {
        let {discusses, defaultAction, recordAction} = this.state
        let id = +e.target.dataset.id
        let target = discusses.find(item => item.id === id)

        // 判断是否操作自己的评论，去掉“私密回复”
        if (this.props.account.id === target.account.id) {
            defaultAction = [
                {label: '删除评论', onClick: () => this.handleDialog('delete')},
                {label: '删除并拉黑', className: 'delete-black', onClick: () => this.handleDialog('deleteAndBlack')}
            ]
        } else {
            defaultAction = [
                {label: '私密回复', onClick: () => this.handleReply()},
                {label: '删除评论', onClick: () => this.handleDialog('delete')},
                {label: '删除并拉黑', className: 'delete-black', onClick: () => this.handleDialog('deleteAndBlack')}
            ]
        }

        // 判断是否设为精选
        if (target.is_filtered) {
            // 判断是否置顶精选
            if (target.is_top) {
                recordAction = [
                    {label: '取消精选', onClick: () => this.manageDiscuss('cancel_filtered')},
                    {label: '取消置顶', onClick: () => this.manageDiscuss('cancel_top')},
                    ...defaultAction
                ]
            } else {
                recordAction = [
                    {label: '取消精选', onClick: () => this.manageDiscuss('cancel_filtered')},
                    {label: '置顶精选', onClick: () => this.handleDialog('top')},
                    ...defaultAction
                ]
            }
        } else {
            recordAction = [
                {label: '设为精选', onClick: () => this.handleDialog('filtered')},
                {label: '置顶精选', onClick: () => this.handleDialog('top')},
                ...defaultAction
            ]
        }
        this.setState({operationDiscuss: target, isActionSheet: true, recordAction, defaultAction})
    }

    showSuccessToast(text) {
        let {successToast} = this.state
        successToast.show = true
        successToast.content = text
        this.setState({successToast})

        setTimeout(() => {
            successToast.show = false
            this.setState({successToast})
        }, 1000)
    }

    showTip(text, type = 'warn') {
        this.setState({
            tip: {show: true, content: text, type},
        })
        setTimeout(() => {
            this.setState({
                tip: {show: false},
            })
        }, 2000)
    }

    componentDidMount() {
        document.title = '评论'
        const {liveroom_id} = this.props.params
        this.setState({liveroomId: liveroom_id}, () => {
            this.fetchDiscussList()
        })
    }

    fetchDiscussList() {
        let liveroomId = this.state.liveroomId
        let {hasUnread} = this.state

        // 判断评论小于10的情况
        if (this.state.discusses && this.state.discusses.length < 10 && hasUnread) {
            let discusses = this.state.discusses.map(item => {
                item.unread = false
                item.show = true
                return item
            })
            this.setState({discusses, has_more: false, hasUnread: false})
            return
        }

        this.setState({loading: true}, () => {
            axios.get(`/api/liveroom/${liveroomId}/discuss_list`, {
                params: {offset: this.state.next_offset ? this.state.next_offset : 0}
            }).then(res => {
                if (res.data.code === 0) {
                    if (!this.state.discusses) {
                        let {discusses, has_more, next_offset, unread_count} = res.data.data
                        let unReadIndex = discusses.findIndex(item => item.unread)
                        // 存在有未读条数并且最后一条是已读
                        hasUnread = unReadIndex > -1 && !discusses[discusses.length - 1].unread

                        // 如果有未读消息，已读的先隐藏
                        discusses = discusses.map(item => {
                            item.show = !(hasUnread && !item.unread)
                            return item
                        })
                        this.setState({discusses, has_more, next_offset, unread_count, initialized: true, loading: false, hasUnread})
                    } else {
                        // 先把已知评论标志为已读
                        let originDisucsses = this.state.discusses
                        if (hasUnread) {
                            originDisucsses = originDisucsses.map(item => {
                                item.unread = false
                                item.show = true
                                return item
                            })
                        }
                        // 重新读取数据
                        let {discusses, has_more, next_offset, unread_count} = res.data.data
                        let unReadIndex = discusses.findIndex(item => item.unread)

                        // 如果上一页有未读并且当前页第一条是已读
                        let hasSplitUnread = false
                        if (this.state.discusses[this.state.discusses.length - 1].unread && unReadIndex === -1 && discusses.length > 0) {
                            hasSplitUnread = true
                        }
                        hasUnread = unReadIndex > -1 && !discusses[discusses.length - 1].unread

                        // 如果有未读消息，已读的先隐藏
                        discusses = discusses.map(item => {
                            item.show = !(hasUnread && !item.unread) && !hasSplitUnread
                            return item
                        })
                        // 拼接原有数据
                        discusses = originDisucsses.concat(discusses)
                        this.setState({discusses, has_more, next_offset, unread_count, loading: false, hasUnread, hasSplitUnread})
                    }
                }
            }).catch(error => {
                if (error.response) {
                    this.props.dispatch({
                        type: 'ERROR_SHOW',
                        payload: {
                            tips: error.response.status === 403 ? '你不是管理员，无法访问该页面' : '服务器出现拥挤了，请联系管理员',
                            img: errorImg,
                            href: `/liveroom/${liveroomId}?fr=discuss_error`,
                            btn: `回到直播间`
                        }
                    })
                }
            })
        })
    }

    handleSendPrivateComment() {
        if ((this.state.privateText && this.state.privateText.trim() === '') || !this.state.privateText) {
            return this.showTip('评论不能为空')
        }
        let {operationDiscuss, discusses} = this.state
        this.setState({isPending: true})
        axios.post(`/api/lecture/${operationDiscuss.lecture.id}/discuss/${operationDiscuss.id}/private_reply`, qs.stringify({
            msg_type: 'text',
            content: this.state.privateText,
            receiver_id: this.state.operationDiscuss.account.id,
        })).then(res => {
            this.setState({isPending: false})
            if (res.data.code === 0) {
                let index = discusses.findIndex(item => item.id === operationDiscuss.id)
                discusses[index].private_reply = true
                this.setState({discusses})
                this.showSuccessToast('发送成功')
                this.setState({privateText: '', isShowPrivateReplyDialog: false})
            } else {
                this.showTip(res.data.msg)
            }
        })
    }

    deleteDiscuss(isHideToast = false) {
        let {operationDiscuss, discusses} = this.state
        axios.post(`/api/classroom/${operationDiscuss.lecture.id}/discuss/${operationDiscuss.id}/delete`)
            .then(res => {
                this.close()
                if (res.data.code === 0) {
                    discusses = discusses.filter(item => item.id !== operationDiscuss.id)
                    this.setState({discusses})
                    if (!isHideToast) this.showSuccessToast('删除成功')
                } else {
                    this.showTip(res.data.msg)
                }
            })
    }

    deleteAndBlack() {
        let {liveroomId, operationDiscuss} = this.state
        axios.post(`/api/liveroom/${liveroomId}/block_account`, qs.stringify({
            account_id: operationDiscuss.account.id,
        })).then(res => {
            this.close()
            if (res.data.code === 0) {
                this.showSuccessToast('拉黑成功')
                this.deleteDiscuss(true)
            } else {
                this.showTip(res.data.msg)
            }
        })
    }

    render() {
        const {operationDiscuss, defaultAction, recordAction, defaultDialog} = this.state;
        const {error} = this.props;

        if (error.showError) {
            return (
                <div className="user-reviews-page_error wk-page">
                    <WKError/>
                </div>
            )
        }
        if (!this.state.initialized) {
            return (
                <div className="user-reviews-page wk-page">
                    <Preload/>
                </div>
            )
        }
        if (this.state.discusses && this.state.discusses.length === 0) {
            return (
                <div className="user-reviews-page wk-page">
                    <div className='no-reviews'>
                        <NoneItem
                            img="https://static-1253442168.image.myqcloud.com/picture/5915685_83a6201fde722ab5078f24fe171ed444.jpg"
                            text="暂时没有评论"/>
                    </div>
                </div>
            )
        }
        return (
            <div className='user-reviews-page wk-page'>
                <ActionSheet
                    menus={operationDiscuss && operationDiscuss.lecture.lecture_mode !== 'default' ? recordAction : defaultAction}
                    actions={[{label: '取消', onClick: e => this.setState({isActionSheet: false})}]}
                    show={this.state.isActionSheet}
                    type="ios"
                    onRequestClose={e => this.setState({isActionSheet: false})}
                />
                <Dialog type="ios" title={defaultDialog.title} buttons={defaultDialog.buttons}
                        show={defaultDialog.show} className={defaultDialog.content === '' ? 'weui-dialog-no-bd' : ''}>
                    {defaultDialog.content}
                </Dialog>
                <Toast icon="success-no-circle"
                       show={this.state.successToast.show}>{this.state.successToast.content || '操作成功'}</Toast>
                <Toast icon="loading" show={this.state.isPending}/>
                <Toptips type={this.state.tip.type} show={this.state.tip.show}>{this.state.tip.content}</Toptips>

                <div className='has-reviews'>
                    {this.state.discusses.map((item, index) =>
                        item.show &&
                        <div className="list-item" key={index}>
                            <div className='top-box'>
                                <div className="info-box">
                                    <img className="avatar" src={item.account.small_avatar_url} alt=""/>
                                    <div className="info-right">
                                        <div className="nameBox">
                                            {(!item.is_top && !item.is_filtered && !item.private_reply && !item.published) ?
                                                <span className='name' style={{maxWidth: '100%'}}>{item.account.nickname}</span>
                                                :
                                                <span className='name'>{item.account.nickname}</span>
                                            }
                                            {item.is_top && <span className="tag">已置顶</span>}
                                            {item.is_filtered && <span className="tag">已精选</span>}
                                            {item.private_reply && <span className="tag">已回复</span>}
                                            {item.published && <span className="tag">已上墙</span>}
                                        </div>
                                        <div className="time">{TimeStream(item.timestamp, 'CN_MD_HM')}</div>
                                    </div>
                                </div>
                                <p className="desc">{item.content}</p>
                            </div>
                            <div className="bot-box">
                                <div className="tit" onClick={() => item.lecture.lecture_mode === 'default' ?
                                    location.assign(`/classroom/${item.lecture.id}`) : location.assign(`/lecture/${item.lecture.id}`)}>
                                    {item.lecture.name}
                                </div>
                                <div className="operation" data-id={item.id} onClick={this.showOperation}>操作</div>
                            </div>
                        </div>
                    )}
                    {(this.state.hasUnread || this.state.hasSplitUnread) ?
                        <div className="tips-text" onClick={() => this.fetchDiscussList()}>点击展示所有评论</div>
                        :
                        <WKInfiniteScroll
                            onTouchBottom={() => this.fetchDiscussList()}
                            isStop={this.state.loading}
                            distance={300}
                            isKill={!this.state.has_more}
                            isShowLoading={true}
                        />
                    }
                    {!this.state.has_more && !this.state.hasUnread &&
                    <div className="tips-text tips-text__over">加载完毕</div>
                    }
                </div>

                <WKCommentDialog type="ios"
                                 title='私密回复'
                                 buttons={[{
                                     type: 'default',
                                     label: '取消',
                                     onClick: () => this.setState({isShowPrivateReplyDialog: false})
                                 }, {
                                     type: 'primary',
                                     label: '发送',
                                     onClick: () => {
                                         this.handleSendPrivateComment()
                                     }
                                 }]}
                                 show={this.state.isShowPrivateReplyDialog}>
                    <div className="recorded-textarea">
                    <textarea rows="3" value={this.state.privateText} placeholder='私密回复将通过站内消息发送给学员，回复后不能撤回或删除'
                              onChange={(e) => this.setState({privateText: e.target.value})}/>
                    </div>
                </WKCommentDialog>
            </div>
        )
    }
}

export default connect((state) => ({
    error: state.error,
    account: state.account
}))(UserReviewsPage)


// WEBPACK FOOTER //
// ./src/pages/UserReviewsPage.js